// Talks to /api/v1/admin — the permission-gated user & permission management surface. The caller
// supplies the API bearer + identity hints. Every endpoint is gated server-side on the caller's own
// permission set; a 403 surfaces as a thrown error.
import { authHeaders, type AuthArgs } from './authArgs';

export interface UserPermissionSummary {
  email: string;
  permissions: string[];
}

export interface PermissionInfo {
  name: string;
  description?: string | null;
}

export async function getAdminUsers(auth: AuthArgs): Promise<UserPermissionSummary[]> {
  const res = await fetch('/api/v1/admin/users', { method: 'GET', headers: authHeaders(auth) });
  if (!res.ok) throw new Error(`admin users ${res.status}: ${await res.text()}`);
  return (await res.json()) as UserPermissionSummary[];
}

export async function getAdminPermissions(auth: AuthArgs): Promise<PermissionInfo[]> {
  const res = await fetch('/api/v1/admin/permissions', { method: 'GET', headers: authHeaders(auth) });
  if (!res.ok) throw new Error(`admin permissions ${res.status}: ${await res.text()}`);
  return (await res.json()) as PermissionInfo[];
}

export async function setUserPermissions(
  auth: AuthArgs,
  args: { email: string; permissions: string[] },
): Promise<string[]> {
  const res = await fetch(`/api/v1/admin/users/${encodeURIComponent(args.email)}/permissions`, {
    method: 'PUT',
    headers: authHeaders(auth),
    body: JSON.stringify({ permissions: args.permissions }),
  });
  if (!res.ok) throw new Error(`set permissions ${res.status}: ${await res.text()}`);
  return (await res.json()) as string[];
}
